import React from 'react';
import { Reveal } from './Reveal';
type Volume = {
  number: string;
  title: string;
  description: string;
  tags: string[];
  featured?: boolean;
};
const volumes: Volume[] = [{
  number: 'VOLUME 01',
  title: '🌟 Tarot Decoded: The Complete Reference Guide',
  description: 'All 78 cards decoded with meanings, keywords, symbolism, affirmations, elemental and astrological correspondences, spread guides, and printable reference charts.',
  tags: ['78 Cards Decoded', 'Spread Guides', 'Printable Charts']
}, {
  number: 'VOLUME 02',
  title: '⚡ Reiki Decoded: The Complete Reference Guide',
  description: 'All traditional symbols, hand positions, chakra sequences, distance healing protocols, and session guides in one complete reference.',
  tags: ['Symbol Reference', 'Hand Positions', 'Session Protocols'],
  featured: true
}, {
  number: 'VOLUME 03',
  title: '🌀 Chakras Decoded: The Complete Reference Guide',
  description: 'All 7 chakras decoded with color, element, frequency, crystals, oils, and affirmations. Includes diagnosis guides and rebalancing protocols.',
  tags: ['7 Chakras Decoded', 'Correspondence Charts', 'Rebalancing Guides']
}, {
  number: 'VOLUME 04',
  title: '🔮 Pendulum Decoded: The Complete Reference Guide',
  description: 'Pendulum selection, programming, and advanced technique with 20+ professional dowsing charts for chakras, health, and crystals.',
  tags: ['20+ Dowsing Charts', 'Programming Guide', 'Printable Charts'],
  featured: true
}, {
  number: 'VOLUME 05',
  title: '🌿 Energy & Wellness Decoded: The Complete Reference Guide',
  description: 'Aura layers, frequency healing, sound therapy, color therapy, and breathwork with printable wellness assessment tools.',
  tags: ['Aura Field Maps', 'Frequency Charts', 'Wellness Protocols']
}, {
  number: 'VOLUME 06',
  title: '🔥 Sacred Cleansing Decoded: The Complete Reference Guide',
  description: 'Space clearing, protection rituals, moon cycle practices, and elemental magic with ready-to-use ceremony checklists.',
  tags: ['Ritual Checklists', 'Moon Cycle Maps', 'Cleansing Protocols']
}];
export function Modules() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-146" data-mp="2mp2jp298zl7h">
      <div className="mx-auto max-w-6xl" data-id="element-147" data-mp="28o86m6b98w2h">
        <Reveal className="mx-auto max-w-3xl text-center" data-id="element-148" data-mp="28pb10o7sdgn5">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-149" data-mp="2cojqhgvsmscw">
            📚 6 Complete Premium <span className="text-sage" data-id="element-150" data-mp="30ee3byg44gx5">Reference Volumes</span>
          </h2>
          <p className="mt-5 text-slate" data-id="element-151" data-mp="35dzd73wtm9on">
            Every discipline decoded. Every correspondence mapped. Every tool ready to print and use
            today.
          </p>
        </Reveal>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-152" data-mp="2rkrk17t3d64u">
          {volumes.map((volume, index) => <Reveal key={volume.number} delay={index % 2 * 0.06} data-id="element-153" data-mp="2vm31gq1tal1y" data-mpi={index}>
              <article className={`flex h-full flex-col rounded-2xl border bg-surface p-8 shadow-premium ${volume.featured ? 'border-amber/50' : 'border-navy/10'}`} data-id="element-154" data-mp="3jcyrbhmpj66k">
                <p className="text-xs font-bold uppercase tracking-[0.15em] text-sage" data-id="element-155" data-mp="1cozqtlz5djh8">
                  {volume.number}
                </p>
                <h3 className="mt-4 font-serif text-2xl leading-tight text-navy" data-id="element-156" data-mp="17pvhmvc83lqw">{volume.title}</h3>
                <p className="mt-4 flex-1 text-sm leading-7 text-slate" data-id="element-157" data-mp="1merr8wtxh6tm">{volume.description}</p>
                <ul className="mt-6 flex flex-wrap gap-2" data-id="element-158" data-mp="1hgq5g454ateg">
                  {volume.tags.map(tag => <li key={tag} className="rounded-full bg-amber-pale px-3 py-1.5 text-xs font-semibold text-navy" data-id="element-159" data-mp="trow8eogne84">
                      {tag}
                    </li>)}
                </ul>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}